
<template>
     <div class="py-3 relative flex flex-col min-h-screen justify-start md:flex-row md:space-x-4" id="flex-item">
     <!-- relative flex flex-col flex-grow min-h-screen -->
    <!-- ===================================================================-->
    <!-- main product page    -->
    <!-- ===================================================================-->

    <div   class=" w-full md:w-2/3 mb-1 min-h-screen md:h-screen md:overflow-y-scroll  md:overscroll-auto">

          <list   class="w-full">
            <!-- .filter((item, index) => gruppe.indexOf(item) === index) -->

              <list-item v-for = "(product, pIdx) in getProducts" :key="product.id"
              :product="product"
              class="pb-4"
              :myClass="listItemCssClass(pIdx)"
              @add-to-cart="updateCart()"
              @expanded="expandedEvent"
              :showDetails="expandedAlbumID == product.id"
              :cartQuantity ="getcartItemQuantity(product.posnr)"
              >
              </list-item>

          </list>

    </div>

      <!-- ===================================================================-->
      <!-- Basket  -->
      <!-- ===================================================================-->
    <div class="flex flex-col  hidden md:block w-1/3 schadow-sm min-h-screen md:h-screen  md:overflow-y-scroll  md:overscroll-auto">
             <basket class="w-full fixed bottom-1 "  :cart="cart">
            </basket>
    </div>
    <!-- ===================================================================-->
    <!-- Basket only for the mobile version  -->
    <!-- ===================================================================-->
        <!-- Here comes the shopping cart as modal only for the  mobile view  -->

        <!-- ===================================================================-->
        <!-- Here is the button that shows the modal  -->
        <!-- The following button will display only if  thre is an item in the cart.
        If the cart is empty then it will be disappeared-->
        <!-- ===================================================================-->
      <div v-if="showBasket" id="cartModal"
          class="md:hidden bg-warmGray-300 fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen
            pt-4 px-4 pb-20 text-center sm:block sm:px-2">
               <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-200 opacity-75"></div>
                </div>
                    <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true">
                  &#8203;
                </span>
                <!--Modal panel, show/hide based on modal state.
                Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
                Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
               -->
                <div class="w-full inline-block align-bottom bg-warmGray-50
                rounded-lg text-left overflow-hidden shadow-xl
                transform transition-all sm:my-8 sm:align-middle
                sm:max-w-lg sm:w-full"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline">
                    <button @click="showModals" >
                        <div class="reltiave bg-warmGray-200 m-2">
                            <span class="mb-4 px-2 h-8 w-8 border-2 border-warmGray-600
                            text-namasteBlue rounded-md bg-warmGray-200
                            font-semibold absolute top-1 right-2">
                                x
                                </span>
                                <!-- here  -->

                                <!-- till here  -->

                        </div>
                        </button>
                    <basket
                    class="mt-4 min-h-screen md:max-w-d"
                    :cart="cart"
                    :basketItems="cartproducts">

                    </basket>
                </div>
        </div>
      </div>
      <!--==============================================================-->
      <!-- The following cart-modal-1 is at the moment not working properly
      i.e. it has no scrolling . so if you have a lot of order, you can not see them
      till end. So we have to work on it and make it scrolling. -->
      <cart-modal-1 v-if="false"
      :showOrderButton="true"
      @close="showBasket = false">
      </cart-modal-1>

       <div class="block md:hidden w-full sticky bottom-1  inset-x-0 stickyButton"
        >
         <order-summary-button  v-on:click="showModals"></order-summary-button>
      </div>
  <!-- ===================================================================-->
    <!-- End of the template    -->
    <!-- ===================================================================-->
  </div>
</template>
<script>
// import ListItem from '@/components/ListItem'
import CartModal1 from '@/components/CartModal1.vue'
// import CartModal from '@/components/CartModal.vue'
import ListItem from '@/components/ListItem.vue'
import List from '@/components/List'
import Basket from '@/views/Basket'
// import Btn from '@/components/Btn'
import { mapActions, mapGetters } from 'vuex'
import OrderSummaryButton from '../components/OrderSummaryButton.vue'
import axios from 'axios'
// import CartModal1 from '../components/CartModal1.vue'

export default {
  data () {
    return {
      cart: 0,
      loading: false,
      showBasket: false,
      showOrderButton: false,
      slug: this.$route.params.slug,
      expandedAlbumID: null
    }
  },
  // created () {
  //   this.loading = true
  //   this.$store.dispatch('setProductToStore')
  //   // this.$store.dispatch('fetchProducts')
  //     .then(
  //       () => {
  //         this.loading = false
  //         // console.log(this.slug)
  //       }
  //     )
  // },
  methods: {
    ...mapActions({
      // addProductToCart: 'addProductToCart'
    }),
    getcartItemQuantity (posnr) {
      var item = this.cartproducts.find(item => item.posnr === posnr)
      if (item) return item.quantity
      return 0
    },
    expandedEvent (e) {
      if (e !== this.expandedAlbumID) { this.expandedAlbumID = e } else this.expandedAlbumID = null
    },
    listItemCssClass (index) {
      return index % 2 === 0 ? 'list_item_even_class' : 'list_item_odd_class'
    },
    updateCart () {
      this.cart += 1
      // this.addProductToCart(product)
    },
    showModals () {
      if (this.showBasket) {
        // document.getElementsByTagName('html')[0].classList.remove('overflow-y-hidden')
        this.showBasket = false
      } else {
        this.showBasket = true
        // document.getElementsByTagName('html')[0].classList.add('overflow-y-hidden')
      }
    },
    checkValue (val) {
      return val === this.slug
    },
    setProductToStore  () {
      axios.get('@/apli/shop2.json')
        .then(response => {
          console.log(response)
        })
    }

  },
  computed: {
    ...mapGetters({
      cartTotal: 'getFormCartTotal',
      lieferkosten: 'getLieferKosten',
      products: 'getAlleProdukte',
      gruppe: 'getGruppe',
      gruppenUrls: 'getGruppenUrls',
      cartproducts: 'getCartProducts',
      totalCartItems: 'getTotalCartItems'
    }),
    getCartLength () {
      return this.cartproducts.length
    },
    getProducts () {
      var cProducts = []
      // console.log(this.slug)
      // find the name of distnation id.
      if (this.slug) {
        // console.log('slug:' + this.slug)
        var _idx = this.gruppenUrls.indexOf(this.slug)
        // console.log(_idx)
        var slugName = ''
        if (_idx >= 0) {
          slugName = this.gruppe[_idx]
          // for (var i = 0; i < this.products.length; ++i) {
          //   // console.log('gruppe: ')
          //   // console.log(this.products[i].gruppe[0] + ':' + slugName)
          // }
          //  state.vegan = state.allProducts.filter((item) => item.gruppe.includes('Vegan'))
          cProducts = this.products.filter(
            (item) => item.gruppe.includes(slugName)
          )
        }
      } else {
        cProducts = this.products
      }
      return cProducts
    }

  },
  watchers: {

  },
  components: {
    // List,
    ListItem,
    List,
    Basket,
    OrderSummaryButton,
    // CartModal,
    CartModal1

  }
}
</script>
<style scoped>
   .stickyButton{
      position: -webkit-sticky;
      align-self: flex-start;
      position: sticky;
      bottom: 0px !important;
   }
   .list_item_even_class{
      background-color: aquamarine;
   }
   .list_item_odd_class{
     background-color: brown;
   }
   #flex-item{
    flex: 1 1 0 !important;
   flex-grow: 1 !important;
   flex-shrink: 1;
   flex-basis: 0  !important;
   text-align: center;
   display: -webkit-flex;
   display: -ms-flexbox;
    /* border: 1px solid rgb(163, 160, 160); */

   }
   #main-content::-webkit-scrollbar
  {
    width: 100px;
    background-color: #2c35b1;
  }
  /*
 *  STYLE 3
 */

#main-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#main-content::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

#main-content::-webkit-scrollbar-thumb
{
  background-color: #F90;
  background-image: -webkit-linear-gradient(45deg,
                                            rgba(255, 255, 255, .2) 25%,
                        transparent 25%,
                        transparent 50%,
                        rgba(255, 255, 255, .2) 50%,
                        rgba(255, 255, 255, .2) 75%,
                        transparent 75%,
                        transparent)
}

</style>
